import { ApiUtil } from '..';

export const viewerApi = {
    // 링크
    getTchEvlTaskInfo: (param: EvlTaskInfo.Req) => {
        return ApiUtil.get<EvlTaskInfo.Res>('/tch/eval/task/info', param);
    },
};
